import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CookiesPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white pt-24 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Política de Cookies</h1>
        <p className="text-slate-500 mb-8">www.agencia-ppc.es</p>
        
        <div className="prose prose-slate max-w-none">
          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">1. ¿Qué es una cookie?</h2>
          <p className="text-slate-600 mb-4">
            Una cookie es un pequeño archivo de texto que se almacena en su dispositivo (ordenador, smartphone, tableta) cuando visita un sitio web. Permite que el sitio recuerde cierta información sobre usted, como sus preferencias de navegación, para mejorar su experiencia de usuario.
          </p>
          <p className="text-slate-600 mb-4">
            Las cookies que utilizamos no permiten identificarle personalmente. Solo sirven para registrar datos relacionados con su navegación (páginas visitadas, duración de la visita, etc.) para facilitar sus visitas futuras.
          </p>

          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">2. Responsable del tratamiento</h2>
          <p className="text-slate-600 mb-4">
            El editor del sitio es: Ulysse Julien Berneau, empresario individual registrado como Autónomo en España bajo el régimen RETA (NIE: Y5618264E), con domicilio en Calle Castillejos 276, SA2A 08025 Barcelona. Determina los fines y los medios de los tratamientos de datos relacionados con las cookies como Responsable del tratamiento, conforme al Reglamento (UE) 2016/679 (RGPD).
          </p>

          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">3. ¿Por qué utilizamos cookies?</h2>
          <p className="text-slate-600 mb-2">Utilizamos diferentes tipos de cookies para:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
            <li>Garantizar el correcto funcionamiento del sitio y personalizar su navegación (cookies técnicas).</li>
            <li>Medir la audiencia y el rendimiento del sitio (cookies analíticas).</li>
            <li>Mostrar publicidad relevante en sitios de terceros (cookies publicitarias, sujetas a su consentimiento).</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">4. Lista de cookies utilizadas</h2>
          <div className="overflow-x-auto mb-4">
            <table className="min-w-full border border-slate-200 rounded-lg">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">Nombre</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">Finalidad</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 text-sm text-slate-600 border-b">GCLICK</td>
                  <td className="px-4 py-3 text-sm text-slate-600 border-b">Seguimiento analítico de campañas publicitarias de Google Ads</td>
                  <td className="px-4 py-3 text-sm text-slate-600 border-b">1 año</td>
                </tr>
                <tr>
                  <td className="px-4 py-3 text-sm text-slate-600">COOKIE CONSENTIMIENTO</td>
                  <td className="px-4 py-3 text-sm text-slate-600">Gestión de su consentimiento para el uso de cookies</td>
                  <td className="px-4 py-3 text-sm text-slate-600">6 meses</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">5. ¿Quién coloca las cookies?</h2>
          <p className="text-slate-600 mb-4">
            Las cookies son colocadas directamente por el Editor o por proveedores técnicos (encargados del tratamiento) que actúan en su nombre.
          </p>

          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">6. Consentimiento para el uso de cookies</h2>
          <p className="text-slate-600 mb-2">Durante su primera visita al sitio, un banner le informará sobre el uso de cookies. En ese momento, usted puede:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
            <li>Aceptar todas las cookies</li>
            <li>Rechazar todas las cookies</li>
          </ul>
          <p className="text-slate-600 mb-4">
            Puede modificar su consentimiento en cualquier momento a través del banner de gestión de cookies.
          </p>

          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">7. Gestión de cookies en los navegadores</h2>
          <p className="text-slate-600 mb-2">Puede configurar su navegador para bloquear o eliminar cookies en cualquier momento. Aquí están los enlaces a las páginas de ayuda de los principales navegadores:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
            <li><a href="https://support.microsoft.com/es-es/topic/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Internet Explorer</a></li>
            <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Microsoft Edge</a></li>
            <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Safari (Mac/iOS)</a></li>
            <li><a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google Chrome</a></li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">8. Más información</h2>
          <p className="text-slate-600 mb-4">
            Para más información sobre sus derechos y la gestión de cookies, puede consultar el sitio web de la Agencia Española de Protección de Datos (AEPD): <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.aepd.es</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;
